import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, SectionCard, EmptyState, Chip } from "../components/Common";
import { ClipboardList } from "lucide-react";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data || [])); }, []);
  return (
    <div className="p-6 lg:p-8 space-y-6">
      <PageHeader title="Audit Log" subtitle="Tamper-resistant record of sensitive activity." />
      <SectionCard>
        {items.length === 0 ? <EmptyState icon={ClipboardList} title="No audit events yet" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
                <tr>
                  <th className="text-left px-4 py-2.5">Timestamp</th>
                  <th className="text-left px-4 py-2.5">User</th>
                  <th className="text-left px-4 py-2.5">Role</th>
                  <th className="text-left px-4 py-2.5">Action</th>
                  <th className="text-left px-4 py-2.5">Entity</th>
                  <th className="text-left px-4 py-2.5">Meta</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {items.map((a) => (
                  <tr key={a.audit_id}>
                    <td className="px-4 py-2 text-xs tabular text-slate-600">{new Date(a.timestamp).toLocaleString()}</td>
                    <td className="px-4 py-2">{a.user_name || "—"}</td>
                    <td className="px-4 py-2 capitalize"><Chip tone="slate">{a.role || "—"}</Chip></td>
                    <td className="px-4 py-2 text-slate-800">{a.action}</td>
                    <td className="px-4 py-2 text-slate-500">{a.entity} · {a.entity_id?.slice(-6)}</td>
                    <td className="px-4 py-2 text-xs text-slate-500 max-w-md truncate">{JSON.stringify(a.meta)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
}
